export const cepNumerico = (cep: string): string => {
    let numbers = cep.replace(/\D/g, '');

    if (numbers.length < 8) {
        const zeros = '0'.repeat(8 - numbers.length);
        numbers = zeros + numbers;
    }

    return numbers;
};